import React from 'react'

export default function Footer() {
    return (
        <>
            <div class=" kilimanjaro_bottom_header_one section_padding_50 text-center">
                <div class="container2">
                    <div class="row">
                        <div class="col-12">
                            <p id="foot">Welcome to <a href="https://www.flipkart.com">Saswat-E-commerce.com<i class="fa fa-love"></i></a> the fastest growing E-Commerce company</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
